import { render, staticRenderFns } from "./PBox.vue?vue&type=template&id=31e3da7e&scoped=true"
import script from "./PBox.vue?vue&type=script&lang=js"
export * from "./PBox.vue?vue&type=script&lang=js"
import style0 from "./PBox.vue?vue&type=style&index=0&id=31e3da7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e3da7e",
  null
  
)

export default component.exports